// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App'
import router from './router'
import store from './store'
import i18n from './constants/lang/i18n'
import { Validator } from 'vee-validate'

Validator.extend('youtubeLink', {
  getMessage: () => '',
  validate: value => /(?:src="|^)https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9]+)(?="|$)/.test(value)
})

require('./plugins/validation')
require('./plugins/localstorage')

Vue.config.productionTip = false

Vue.use(VueMeta)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js